import React, { useState, useEffect } from 'react';
import { Modal, List, Switch, Typography, Button, message, Space, Alert } from 'antd';
import { SettingOutlined, SaveOutlined } from '@ant-design/icons';
import { useConfig } from '../../../context/ConfigContext';

const { Text, Title } = Typography;

const CAMPOS_DISPONIBLES = [
  { key: 'apellido', label: 'Apellidos' },
  { key: 'nombre_comercial', label: 'Nombre Comercial / Tienda' },
  { key: 'documento', label: 'NIT / CC (Documento)' },
  { key: 'telefono', label: 'Teléfono (WhatsApp)' },
  { key: 'email', label: 'Correo Electrónico' },
  { key: 'zona_id', label: 'Zona / Ruta de Entrega' },
  { key: 'categoria_id', label: 'Tipo de Cliente' },
  { key: 'ciudad', label: 'Ciudad / Municipio' },
  { key: 'barrio', label: 'Barrio / Sector' },
  { key: 'direccion', label: 'Dirección Física' },
];

const ModalConfigCampos = ({ isOpen, setIsOpen }) => {
  const { config, updateConfig } = useConfig();
  const [configLocal, setConfigLocal] = useState({});
  const [saving, setSaving] = useState(false);

  // Cargar la configuración actual cuando se abre el modal
  useEffect(() => {
    if (isOpen) {
      try {
        const parseado = JSON.parse(config?.settings?.campos_clientes || "{}");
        setConfigLocal(parseado);
      } catch (e) {
        setConfigLocal({});
      }
    }
  }, [isOpen, config?.settings?.campos_clientes]);

  const handleToggleRequerido = (key, checked) => {
    setConfigLocal(prev => ({
      ...prev,
      [key]: {
        ...prev[key],
        requerido: checked
      }
    }));
  };

  const handleGuardar = async () => {
    setSaving(true);
    try {
      await updateConfig({
        campos_clientes: JSON.stringify(configLocal)
      });
      message.success("Configuración de campos guardada correctamente");
      setIsOpen(false);
    } catch (error) {
      message.error("Error al guardar la configuración");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title={
        <Space>
          <SettingOutlined style={{ color: '#22BABB', fontSize: '20px' }} />
          <Title level={5} style={{ margin: 0 }}>Configurar Campos del Cliente</Title>
        </Space>
      }
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      footer={
        <Button 
          type="primary" 
          icon={<SaveOutlined />} 
          onClick={handleGuardar} 
          loading={saving}
          style={{ backgroundColor: '#22BABB', borderRadius: '8px', fontWeight: 600 }}
        >
          Guardar Cambios
        </Button>
      }
      width={500}
      centered
    >
      <Alert 
        message={<Text style={{ fontSize: '13px', color: '#0369a1' }}>Selecciona qué campos serán obligatorios para toda la empresa. El "Nombre" siempre es requerido.</Text>} 
        type="info" 
        showIcon 
        style={{ 
          marginBottom: '16px', 
          borderRadius: '8px', 
          padding: '8px 12px', 
          backgroundColor: '#e0f2fe', 
          border: '1px solid #bae6fd',
          alignItems: 'center'
        }}
      />
      
      <div style={{ maxHeight: '50vh', overflowY: 'auto' }} className="scroll-personalizado">
        <List
          size="small"
          dataSource={CAMPOS_DISPONIBLES}
          renderItem={item => {
            const isRequerido = configLocal[item.key]?.requerido || false;
            return (
              <List.Item
                style={{ 
                  padding: '12px 16px', 
                  backgroundColor: isRequerido ? '#f0f9f9' : '#fff',
                  borderBottom: '1px solid #f0f0f0',
                  transition: 'background 0.3s'
                }}
                extra={
                  <Switch 
                    checked={isRequerido} 
                    onChange={(checked) => handleToggleRequerido(item.key, checked)}
                    style={{ backgroundColor: isRequerido ? '#22BABB' : undefined }}
                  />
                }
              >
                <Text strong style={{ color: isRequerido ? '#0f172a' : '#475569' }}>
                  {item.label}
                </Text>
              </List.Item>
            );
          }}
        />
      </div>
    </Modal>
  );
};

export default ModalConfigCampos;